import React from 'react';
import styled from 'styled-components';

export const Heading2 = styled.h2`
  padding: 12px 16px 12px 20px;
  margin: 0;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  width: 100%;
`;

export default Heading2;
